import React from "react";
import { red100 } from "material-ui/styles/colors";
import { SERVER } from "../redux/apolloClient";
class OnlineBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOnline: false };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      fetch("https://" + SERVER + "/graphql?keepAlive", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: `
            query Teams {
              teams {
                id
              }
            }
          `,
        }),
      }).then(
        // fetch("https://jsonplaceholder.typicode.com/todos/1").then(
        //   fetch("http://localhost:3050/messages/1").then(
        (res) => {
          this.setState({ isOnline: true });
        },
        (reason) => {
          this.setState({ isOnline: false });
        }
      );
    }, 1000);
  }

  componentWillUnmount() {
    console.log("Clearing Interval", this.interval);
    clearInterval(this.interval);
  }

  render() {
    return (
      <React.Fragment>
        {this.state.isOnline ? (
          this.props.children
        ) : (
          <div
            style={{
              display: "flex",
              height: "100%",
              marginTop: "-4px",
              background: red100,
              padding: "0 80px",
            }}
          >
            <span style={{ display: "flex", alignItems: "center" }}>🔴OFFLINE</span>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default OnlineBanner;



// WEBPACK FOOTER //
// ./src/components/OnlineBanner.jsx